<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Envoi d'un SMS</mat-card-title>
        <div class="mat-card-header-buttons small">
            <mat-form-field class="basic-button form-item without-error" appearance="outline">
                <mat-label>Modèle</mat-label>
                <mat-select [(ngModel)]="selectedTemplateId" (selectionChange)="applyTemplate($event.value)" matTooltip="Sélection d’un modèle de SMS">
                    <mat-option value="0">Aucun modèle</mat-option>
                    @for (template of templates; track template.id) {
                        <mat-option [value]="template.id">{{ template.name }}</mat-option>
                    }
                    <ngx-spinner name="sms-template-spinner" [fullScreen]="false" type="timer" size="small"></ngx-spinner>
                </mat-select>
            </mat-form-field>
            <button
                mat-mini-fab
                class="basic-button"
                aria-label="Ouvrir le carnet des contacts"
                matTooltip="Ouvrir le carnet des contacts"
                matTooltipPosition="below"
                (click)="displayContacts()">
                <fa-icon [icon]="contactsBookIcon"></fa-icon>
            </button>
        </div>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <div class="form-item">
                <mat-form-field class="mat-form-field-recipients">
                    <mat-label>Destinataires</mat-label>
                    <mat-chip-grid #toChipList multiple [formControl]="recipientsFormControl" required>
                        @for (item of sms.to; track $index) {
                            <mat-chip-row selectable="false" removable="true" (removed)="removeMobileNumber(item)">
                                {{ item }}
                                <mat-icon matChipRemove>cancel</mat-icon>
                            </mat-chip-row>
                        }
                        <input
                            tabindex="2"
                            class="mobile-number-input"
                            [matChipInputFor]="toChipList"
                            [formControl]="recipientInputFormControl"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            matChipInputAddOnBlur="true"
                            (matChipInputTokenEnd)="addMobileNumber($event)"
                            (paste)="pasteMobileNumbers($event)" />
                    </mat-chip-grid>
                    @if (sms.to.length === 0 && (recipientsFormControl?.dirty || recipientsFormControl?.touched) && recipientsFormControl.hasError('required')) {
                        <mat-error>Le champ destinataires est obligatoire</mat-error>
                    }
                    @if ((recipientsFormControl?.dirty || recipientsFormControl?.touched) && recipientsFormControl.hasError('maxRecipients')) {
                        <mat-error>Le champ destinataires est limité à 5 destinataires</mat-error>
                    }
                    @if (recipientsFormControl.hasError('invalidFormat') && (recipientsFormControl?.dirty || recipientsFormControl?.touched)) {
                        <mat-error>Le n° de téléphone est invalide</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="form-item">
                <mat-form-field class="mat-form-field-content">
                    <mat-label>Contenu</mat-label>
                    <textarea matInput tabindex="3" rows="6" [formControl]="contentFormControl" autocomplete="off" required></textarea>
                    @if (contentFormControl.hasError('required') && (contentFormControl?.dirty || contentFormControl?.touched)) {
                        <mat-error>Le contenu est obligatoire</mat-error>
                    }
                </mat-form-field>
                <div class="progress">
                    <div #progressBar class="progress-bar"></div>
                </div>
                <p #charsCounter class="chars-counter">&nbsp;</p>
            </div>
        </div>
        <ngx-spinner name="send-sms-spinner" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        <button mat-raised-button class="accent-button" (click)="send()" [disabled]="false">Envoyer</button>
    </mat-card-actions>
</mat-card>
